import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Typography } from "@mui/material";
import React from "react";
import { useStyles } from "../Common/CommonStyle";
import DialogBox from "./DialogBox";
import VideoPlayer from "./VideoPlayer";

export interface ISuccess {
  message1: string;
  message2: string;
  displayNextSlide: () => void;
  consoleImg?: boolean;
}

const Success = (props: ISuccess) => {
  const classes = useStyles();
  const [nextSlide, showNextSlide] = React.useState(0);

  const proceedClick = () => {
    showNextSlide(1);
    props.displayNextSlide();
  };

  return (
    <Box
      className={classes.positionComponent}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      {props?.consoleImg && (
        <VideoPlayer
          videoURL={"asset/video/ScanningProgressVideo.mp4"}
          displayNextSlide={() => {}}
          styles={{
            position: "absolute",
            left: "5%",
            top: "11%",
            marginTop: "3rem",
            height: "20%",
            width: "40%",
          }}
        />
      )}
      <DialogBox
        type={0}
        childProps={
          <div
            style={{
              flexDirection: "column",
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
              height: "inherit",
              width: "inherit",
              textAlign: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
              }}
            >
              <CloseIcon
                sx={{ cursor: "pointer", marginRight: "1rem" }}
                onClick={proceedClick}
              />
            </div>
            <CheckCircleOutlineIcon
              sx={{ color: "#74D800", width: "4rem", height: "4rem" }}
            />
            <div>
              <Typography
                variant="subtitle1"
                color="#74D800"
                sx={{ fontWeight: "500" }}
              >
                {props.message1}
              </Typography>
              <Typography
                variant="subtitle1"
                color="#74D800"
                sx={{ fontWeight: "500" }}
              >
                {props.message2}
              </Typography>
            </div>
          </div>
        }
      />
    </Box>
  );
};

export default Success;
